import type { AxiosInstance } from 'axios';
import type { FeatureSet } from '../util/featureSet';
import type { StructuredLogger } from '@mimir/primitive/structuredLogger';
import type { CopyParams, LocalPathCopyResult } from './fileCopyUpload';
import type { BackendClient } from '../util/backendClient';
import type { AdobePanelContext, ElectronContext } from '../context/applicationContext';
import type { Logger } from '../types/logger';


export interface UploadManagerOptions {
  client: BackendClient,
  axios: AxiosInstance,
  // When axios is running with nodejs, the memory associated to the payload
  // buffer is not freed after a PUT operation is complete which causes
  // issues for larg files (#2229). As a workaround, we allow doing the
  // PUT requests with the pure node implementation that does not
  // have this problem
  putChunksWithNode?: boolean,
  getUploadDirectory?(): Promise<string | null>;
  features: FeatureSet;
  logger: Logger;
  getLogger(): StructuredLogger;

  // This function takes care of delegating the copying to the main process if running in Desktop, or
  // copying in the same process if running in Premiere.
  copyFileOptimizedForDesktop?(applicationContext: AdobePanelContext | ElectronContext, params: CopyParams): Promise<LocalPathCopyResult>;

  // Canceling with Axios token does not work across process boundaries in Desktop. This function is for
  // executing a function in the main process to mark it for cancellation.
  cancelCopyFileOptimizedForDesktop?(applicationContext: AdobePanelContext | ElectronContext, executionId: string): void;
  getThisClientInstanceId(): string,
}

export enum UploadState {
  PREPROCESSING = 'preprocessing',
  PROGRESSING = 'progressing',
  WAITING = 'waiting',
  RESUMING = 'resuming',
  PAUSED = 'paused',
  CANCELLED = 'cancelled',
  COMPLETE = 'complete',
  ERROR = 'error',
  SEE_PROGRESS = 'see_progress'
}

